import moment from "moment";
import numeral from "numeral";
import api from "../config/api";
import constants from "./constants";

const headers = {
  "Content-Type": "application/json",
};

const validateEmail = (email) => {
  var re = //eslint-disable-next-line
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};

const createFormEncodedData = function (data) {
  let formEncodedParams = "";
  const keys = Object.keys(data);

  keys.forEach((item, index) => {
    let text = data[item];
    if (typeof text === "object") {
      text = JSON.stringify(text);
    }

    const encoded = encodeURIComponent(text);

    if (index > 0) {
      formEncodedParams += "&";
    }

    formEncodedParams += `${item}=${encoded}`;
  });

  return formEncodedParams;
};

const parsePersonalData = (data) => ({
  "First Name": data.Firstname || data.firstName,
  "Middle Name": data.Middlename || data.middleName,
  "Last Name": data.Lastname,
  Gender: data.Gender,
  "Residential Address1": data.ResidentialAddress1,
  "Residential Address2": data.ResidentialAddress2,
  "State of Residence": data.State_Of_residence,
  Phone: data.Phone || data.mobileNumber,
  "Date of Birth": data.DATE_OF_BIRTH
    ? moment(data.DATE_OF_BIRTH).format("MMM D, YYYY")
    : "",
  Email: data.Email,
  Designation: data.Designation,
  "Employer Name": data.EMPLOYER_NAME,
  "Employer Code": data.EmployerCode,
  "Office Address1": data.OfficeStreetAddress1,
  "Office Address2": data.OfficeStreetAddress2,
  "Office town": data.OfficeTown,
});

const parseNextOfKinData = (data) => ({
  Relationship: data.NOK_RELATIONSHIP,
  Name: data.NOK_NAME,
  Surname: data.NOK_SURNAME,
  "Date Of Birth": data.DATE_OF_BIRTH
    ? moment(data.DATE_OF_BIRTH).format("MMM D, YYYY")
    : "",
  Gender: data.GENDER,
  "Address 1": data.ADDRESS1,
  "Address 2": data.ADDRESS2,
  City: data.CITY,
  State: data.STATE,
  "Mobile Phone": data.NOK_MOBILE_PHONE,
  "Email Address": data.NOK_EMAILADDRESS,
});

const parseEmployerDetails = (data) => ({
  Name: data.name,
  Phone: data.phone,
  Address: data.address,
  "Correspondence Address": data.correspondenceAddress,
  Email: data.email,
});

const getMenuClasses = (isActive) => {
  return isActive
    ? "sidebar-menu-text sidebar-menu-text-active"
    : "sidebar-menu-text";
};

const capatalize = (text) => text[0].toUpperCase() + text.slice(1);

const fetchApi = async (
  route,
  body,
  method,
  authorization = {},
  shouldNotStringify
) => {
  try {
    let stringifiedBody = body;

    if (!shouldNotStringify) stringifiedBody = JSON.stringify(body);

    const headerObject = { ...headers, ...authorization };
    if (shouldNotStringify) delete headerObject["Content-Type"];

    const options = {
      method,
      body: stringifiedBody,
      headers: headerObject,
    };

    if (!body) delete options.body;

    const response = await Promise.race([
      fetch(`${constants.BASE_URL}${route}`, options),
      new Promise((_, reject) =>
        setTimeout(
          () => reject({ message: constants.NETWORK_FAILED_ERROR }),
          constants.TIMEOUT
        )
      ),
    ]);

    // const bodySize = response._bodyBlob._data.size;
    const contentType = response.headers.get("content-type");
    if (!contentType) {
      return { status: response.status, data: "done" };
    }
    // if (!bodySize) {
    //   return { status: response.status, data: "done" };
    // }

    const data = await response.json();
    if (!data.result && data.ErrorMessage) {
      if (data.ErrorMessage) throw new Error(data.ErrorMessage);
      if (data.Message) throw new Error(data.Message);
      throw data;
    }

    if (data.Message) throw new Error(data.Message);
    return { status: response.status, data };
  } catch (e) {
    throw e;
  }
};

const fetchAPIFromBaseURL = async (params) => {
  let timeout;

  try {
    const headerObject = { ...headers, ...params.headers };
    const apiParams = {
      method: params.method,
      body: JSON.stringify(params.body),
      headers: headerObject,
    };

    if (!params.body) {
      delete params.body;
    }

    if (!params.headers) {
      delete params.headers;
    }

    const response = await Promise.race([
      fetch(`${params.baseURL}${params.path}`, apiParams),
      new Promise(
        (_, reject) =>
          (timeout = setTimeout(() => {
            reject({ message: "Network Request Failed" });
          }, 60000 * 2))
      ),
    ]);

    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    const json = await response.json();

    console.log("Response", json);

    if (json.error) {
      throw new Error(json.error);
    }

    return json;
  } catch (e) {
    throw new Error(e);
  }
};

const validationFetch = async (route, body, method, header) => {
  const headerObject = { ...headers, ...header };

  const options = {
    method,
    body: JSON.stringify(body),
    headers: headerObject,
  };

  try {
    const errorObject = {};
    let finalUrl = `${constants.VALIDATION_BASE_URL}${route}`;

    // const isTesting = isTestingUrl(window.location.href);

    // if (isTesting) {
    //   finalUrl = `${constants.VALIDATION_TEST_BASE_URL}${route}`;
    // }

    const response = await fetch(finalUrl, options);

    const jsonResponse = await response.json();

    if (jsonResponse.errorMessages && jsonResponse.errorMessages.length) {
      errorObject.errorMessages = jsonResponse.errorMessages;
    }
    if (
      jsonResponse.errorCode !== "success" &&
      parseInt(jsonResponse.errorCode) !== 0 &&
      jsonResponse.errorMessage &&
      jsonResponse.errorMessage !== "Succesful Request" &&
      jsonResponse.errorMessage !==
        "Requested Credit notification was sucessful!"
    ) {
      throw new Error(jsonResponse.errorMessage);
    }
    // throw { message: jsonResponse.errorMessage, ...errorObject };

    return jsonResponse;
  } catch (e) {
    throw e;
  }
};

const fundFusionValidationFetch = async (route, body, method, header) => {
  const headerObject = { ...headers, ...header };

  const options = {
    method,
    body: JSON.stringify(body),
    headers: headerObject,
  };
  console.log(options);

  try {
    const errorObject = {};
    let finalUrl = `${constants.VALIDATION_BASE_URL}${route}`;

    const response = await fetch(finalUrl, options);

    const jsonResponse = await response.json();

    if (jsonResponse.errorMessages && jsonResponse.errorMessages.length) {
      errorObject.errorMessages = jsonResponse.errorMessages;
    }
    if (
      jsonResponse.errorCode !== "success" &&
      parseInt(jsonResponse.errorCode) !== 0 &&
      jsonResponse.errorMessage &&
      jsonResponse.errorMessage !== "Succesful Request" &&
      jsonResponse.errorMessage !==
        "Requested Credit notification was sucessful!"
    ) {
      throw new Error(jsonResponse.errorMessage);
    }
    // throw { message: jsonResponse.errorMessage, ...errorObject };

    return jsonResponse;
  } catch (e) {
    throw e;
  }
};

const logoutUser = async (props) => {
  const { removeUser } = props;
  const { user } = props;
  const { history } = props;

  try {
    await api.logout(null, user.token);
    sessionStorage.removeItem("user");
    history.replace("/login");
    removeUser();
  } catch (e) {
    sessionStorage.removeItem("user");
    history.replace("/login");
    removeUser();
  }
};

const ifSubmenuSelected = (mainMenu, path) => {
  if (mainMenu === "accountinfo") {
    return path === "/currentbalance" || path === "/transactiondetails";
  }

  if (mainMenu === "enquires") {
    return (
      path === "/pensioncalculator" ||
      path === "/fundprices" ||
      path === "/referral" ||
      path === "/rewardsystem"
    );
  }

  if (mainMenu === "profilesetting") {
    return (
      path === "/personaldetails" ||
      path === "/nextofkin" ||
      path === "/employeedetails" ||
      path === "/changepassword" ||
      path === "/addrole"
    );
  }

  if (mainMenu === "micropension") {
    return path === "/contribution" || path === "/withdrawal";
  }
  if (mainMenu === "enrollment") {
    return path === "/rsapin" || path === "/onboarding";
  }
};

const getIcon = (type, isActive) => {
  if (type === "home") {
    return isActive
      ? require("../assets/icons/home_blue.png")
      : require("../assets/icons/home_grey.png");
  }

  if (type === "micro") {
    return isActive
      ? require("../assets/icons/micro_pension_blue.png")
      : require("../assets/icons/micro_pension_grey.png");
  }

  if (type === "enrollment") {
    return isActive
      ? require("../assets/icons/enroll_blue.png")
      : require("../assets/icons/enroll_grey.png");
  }

  if (type === "accountinfo") {
    return isActive
      ? require("../assets/icons/acc_blue.png")
      : require("../assets/icons/acc_grey.png");
  }

  if (type === "enquires") {
    return isActive
      ? require("../assets/icons/enqui_blue.png")
      : require("../assets/icons/enqui_grey.png");
  }

  if (type === "profilesetting") {
    return isActive
      ? require("../assets/icons/pro_menu_blue.png")
      : require("../assets/icons/pro_menu_grey.png");
  }

  if (type === "downloadforms") {
    return isActive
      ? require("../assets/icons/dwn_blue.png")
      : require("../assets/icons/dwn_grey.png");
  }

  if (type === "selfservice") {
    return isActive
      ? require("../assets/icons/self_blue.png")
      : require("../assets/icons/self_grey.png");
  }

  if (type === "contactus") {
    return isActive
      ? require("../assets/icons/cont_blue.png")
      : require("../assets/icons/cont_grey.png");
  }

  if (type === "faq") {
    return isActive
      ? require("../assets/icons/faq_blue.png")
      : require("../assets/icons/faq_grey.png");
  }

  if (type === "micropension") {
    return isActive
      ? require("../assets/icons/micro_pension_blue.png")
      : require("../assets/icons/micro_pension_grey.png");
  }
};

const formatNumbers = (number, shouldDecimal) => {
  if (!number && number !== 0) return "";
  if (shouldDecimal) return numeral(number).format(",000.00");

  return numeral(number).format(",000");
};

const percentNumber = (num) => `${num.toString()}%`;

const currencyFormat = (num) => numeral(num).format("0.00a");

const generateRandomKey = () =>
  `${Math.random().toString()}-${Math.random().toString()}-${Math.random().toString()}-${Math.random().toString()}-${Math.random().toString()}-${Math.random().toString()}-${Math.random().toString()}`;

const imageToDataURL = (blob) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.addEventListener("load", () => resolve(reader.result), false);

    if (blob) {
      reader.readAsDataURL(blob);
    } else {
      reject({ message: "Please send a proper blob" });
    }
  });
};

const checkPermissionForEmployer = (route) => {
  let shouldNavigate = true;

  // remove '/' from route, if the route is not home
  route = (route.length > 1 && route[0]) === "/" ? route.slice(1) : route;

  // return true if value found in given array, '!' will reverse the boolean
  shouldNavigate = !constants.EMPLOYER_RESTRICTED_ROUTES.some(
    (item) => item === route
  );

  return shouldNavigate;
};

const checkBlockedRoutes = (route) => {
  let shouldNavigate = true;

  // remove '/' from route, if the route is not home
  route = (route.length > 1 && route[0]) === "/" ? route.slice(1) : route;

  // return true if value found in given array, '!' will reverse the boolean
  shouldNavigate = !constants.BLOCKED_ROUTES.some((item) => item === route);

  return shouldNavigate;
};

const checkPermissionForNonMember = (route) => {
  let shouldNavigate = true;

  // remove '/' from route, if the route is not home
  route = (route.length > 1 && route[0]) === "/" ? route.slice(1) : route;

  // return true if value found in given array, '!' will reverse the boolean
  shouldNavigate = !constants.NON_MEMBER_RESTRICTED_ROUTES.some(
    (item) => item === route
  );

  return shouldNavigate;
};

const getSelfBaseUrl = () => {
  const host = window.location.host || "";

  if (host.includes("fortewiz.com")) {
    return `${window.location.origin}/pplwebapp/#`;
  }

  if (host.includes("mobile.premiumpension.com")) {
    return `${window.location.origin}/web/#`;
  }

  return window.location.origin;
};

function splitUrl(url = "") {
  const isHashed = url.search("#") !== -1;

  if (isHashed) {
    const completePath = url.split("#")[1] || "";
    const onlyPath = completePath.split("?")[0] || "";
    const onlyQueryStrings = completePath.split("?")[1] || "";
    return {
      path: onlyPath,
      queryStrings: serializeQueryStrings(onlyQueryStrings),
    };
  }

  if (url[url.length - 1] === "/") {
    url = url.slice(0, url.length - 1);
  }

  const slashIndex = url.lastIndexOf("/");
  const completePath = url.slice(slashIndex);
  const onlyPath = completePath.split("?")[0] || "";
  const onlyQueryStrings = completePath.split("?")[1] || "";

  return {
    path: onlyPath,
    queryStrings: serializeQueryStrings(onlyQueryStrings),
  };
}

function serializeQueryStrings(s = "") {
  const queryStrings = {};

  const arr = s.split("&");

  arr.forEach((item) => {
    const keyValue = item.split("=");

    if (keyValue[0]) {
      queryStrings[keyValue[0]] = keyValue[1];
    }
  });

  return queryStrings;
}

function findBaseURL(rawUrl = "") {
  let url = rawUrl.split("#")[0];

  if (url[url.length - 1] === "/") {
    url = url.slice(0, url.length - 1);
  }

  return url;
}

function isTestingUrl(rawUrl) {
  let isTesting = false;

  for (let i = 0; i < constants.testingDomains.length; i++) {
    const item = constants.testingDomains[i];

    if (rawUrl.includes(item)) {
      isTesting = true;
      break;
    }
  }

  return isTesting;
}

function removeNewLineOrTab(str) {
  if (!str) return str;

  return str.replace(/\n/g, "").replace(/\r/g, "");
}

const isNetworkRequestFailedError = (error) => {  
  return (
    error?.message === constants.NETWORK_FAILED_ERROR ||
    error?.message === constants.FAILED_TO_FETCH
  );
};

const isUserMember = (user) => {
  const roles = user.roles;

  return roles.some((item) => item.id === constants.userRole.Member);
};

export {
  parsePersonalData,
  isUserMember,
  parseNextOfKinData,
  parseEmployerDetails,
  ifSubmenuSelected,
  fetchApi,
  getIcon,
  getMenuClasses,
  capatalize,
  formatNumbers,
  percentNumber,
  currencyFormat,
  generateRandomKey,
  imageToDataURL,
  validationFetch,
  checkPermissionForNonMember,
  checkPermissionForEmployer,
  checkBlockedRoutes,
  getSelfBaseUrl,
  validateEmail,
  splitUrl,
  findBaseURL,
  isTestingUrl,
  logoutUser,
  fundFusionValidationFetch,
  removeNewLineOrTab,
  fetchAPIFromBaseURL,
  createFormEncodedData,
  isNetworkRequestFailedError,
};
